import { render, staticRenderFns } from "./InvoiceContactDetails.vue?vue&type=template&id=41f3caf8&scoped=true"
import script from "./InvoiceContactDetails.vue?vue&type=script&lang=ts"
export * from "./InvoiceContactDetails.vue?vue&type=script&lang=ts"
import style0 from "./InvoiceContactDetails.vue?vue&type=style&index=0&id=41f3caf8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f3caf8",
  null
  
)

export default component.exports